import styled from "styled-components";
import { BotaoEnviar } from "../Botoes";
import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import Modal from 'react-bootstrap/Modal';

function ModalSucesso(props) {
	return (
		<Modal
			{...props}
			size="sm"
			aria-labelledby="form-modal"
			centered
			data-bs-theme="dark"
			autoFocus
		>
			<Modal.Body>
				<MensagemSucesso>Resposta enviada!</MensagemSucesso>
			</Modal.Body>
		</Modal>
	);
}

function ModalErro(props) {
	return (
		<Modal
			{...props}
			size="sm"
			aria-labelledby="form-modal"
			centered
			data-bs-theme="dark"
			autoFocus
		>
			<Modal.Body>
				<MensagemErro>Há perguntas obrigatórias não respondidas.</MensagemErro>
			</Modal.Body>
		</Modal>
	);
}

const MensagemSucesso = styled.span`
	color: #aaffaa;
    display: block;
    font-size: var(--medium-font);
    text-align: center;
`;

const MensagemErro = styled.span`
	color: #ff8383;
    display: block;
    font-size: var(--medium-font);
    text-align: center;
`;

const FormContainer = styled.form`
	display: flex;
	flex-direction: column;
	font-size: var(--smaller-font);
	font-weight: var(--regular-weight);
	display: flex;
	flex-direction: column;
	padding: 2em 2em;
	gap: 0.6em;
	background-color: ${(props) => props.$bgcolor || "rgb(15, 50, 100)"};
	border-radius: var(--border-radius-s);
	width: 100%;

	@media screen and (min-width: 650px) {
		width: 65vw;
		max-width: 600px;
	}
`;

const InputLabel = styled.label`
	padding: ${(props) => props.pad || "0 0 0.2em 0.7em"};
	color: white;
	text-align: center;
	width: 100%;
`;

const Campo = styled.input`
	width: 100%;
	border: none;
	border-radius: 5px;
	padding: 0.4em;
	color: ${(props) => props.$color || "black"};
	background-color: ${(props) => props.$color || "white"};
`;

const TextArea = styled.textarea`
	width: 100%;
	border: none;
	border-radius: 5px;
	padding: 0.4em;
	color: ${(props) => props.$color || "black"};
	background-color: ${(props) => props.$color || "white"};
`;

const Espacador = styled.div`
	width: 100%;
	height: 1em;
	background: transparent;
`;

const RadioWrapper = styled.div`
	width: 100%;
	display: flex;
	background: transparent;
	justify-content: space-evenly;	
`;

const ContainerRadioBtn = styled.div`
	display: flex;
	background: transparent;
	align-items: center;
`;

const Button = styled.button`
	text-align: center;
    text-decoration: none;
    font-size: 1.5em;
    border: solid 3px white;
    background-color: white;
    border-radius: 5px;
`;

const NotasContainer = styled.div`
	display: grid;
    grid-template-columns: repeat(${(props) => props.cols || 10}, 1fr);
    gap: 10px;
`;

const TituloGeral = styled.h1`
	font-weight: var(--strong-weight);
	font-size: var(--bigger-font);
	text-align: left;
	color: ${(props) => props.$color || "black"};
`;

const TituloPesquisa = styled.h1`
	font-weight: var(--medium-weight);
	font-size: var(--big-font);
	text-align: center;
	color: white;
`;

const Separador = styled.hr`
	color: white;
`;

export default function FormPesquisa({
	titulo,
	pesquisas,
	color,
	$bgcolor
}) {
	pesquisas = JSON.parse(pesquisas);

	const {
		register,
		setValue,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm();

	const [modalShowSuccess, setModalSuccessShow] = useState(false);
	const [modalShowError, setModalErrorShow] = useState(false);
	const [permitirLimparNota, setPermitirLimparNota] = useState(true);

	const onSubmit = (data) => {
		let pass = true;

		Object.keys(data).forEach(x => {
			if (!x.startsWith('motivo_')) {
				if (data[x] == null || data[x] == '') {
					setModalErrorShow(true);

					setTimeout(() => {
						setModalErrorShow(false);
					}, 3000);

					pass = false;
				}
			}
		});

		if (pass) {
			alert(JSON.stringify(data));
			console.log(data);
			setModalSuccessShow(true);
			setTimeout(() => {
				setModalSuccessShow(false);
			}, 5000);

			/*
			fetch('/pesquisa', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ ...data }),
			})
				.then((response) => response.json())
				.then((data) => {
					setModalSuccessShow(true);
					reset();

					setTimeout(() => {
						setModalSuccessShow(false);
					}, 1000);
				})
				.catch(() => {
					setModalErrorShow(true);

					setTimeout(() => {
						setModalErrorShow(false);
					}, 3000);
				});
			*/
		}
	};

	const setNotaPesquisa = (ev) => {
		const elementoClicked = ev.target;
		const campoIdClicked = elementoClicked.id.split('-');
		const notaClicked = campoIdClicked[1];
		const idPesquisaClicked = campoIdClicked[0];
		setValue(`nota_${idPesquisaClicked}`, notaClicked);

		// Estilo dos botões
		Array.from(document.getElementsByTagName('button')).forEach(x => {
			const campoIdBotao = x.id.split('-');
			const notaBotao = campoIdBotao[1];
		
			if(x.name == `nota_${idPesquisaClicked}` && notaBotao != notaClicked) {
				x.style.color = 'black';
				x.style.backgroundColor = 'white';
				x.style.border = 'solid 3px white';
			} else if (x.name == `nota_${idPesquisaClicked}` && notaBotao == notaClicked) {
				x.style.color = 'white';
				x.style.backgroundColor = '#88bd28';
				x.style.border = 'solid 3px #88bd28';
			}
		});
	};

	// Gerar campos das pesquisas de forma dinâmica
	const CamposPesquisas = pesquisas.map((val, i) => {
		let elementos = [];

		const tituloPesquisa = val.TEXTO;
		const idPesquisa = val.ID_PESQUISA;
		const notaMin = val.AVALIACAO_MIN;
		const notaMax = val.AVALIACAO_MAX;
		const permitirMotivo = val.MOTIVO_NOTA;
		const tipoNota = val.TIPO_NOTA;

		if (tipoNota == "MÚLTIPLA ESCOLHA") {
			elementos.push(<TituloPesquisa key={`title-${i}`}>{tituloPesquisa}<span style={{ color: "red" }}>*</span></TituloPesquisa>);
		} else {
			elementos.push(<TituloPesquisa key={`title-${i}`}>{tituloPesquisa}</TituloPesquisa>);
		}

		// Gerar campo nota
		if (tipoNota == "NOTA") {
			let nota = notaMin;
			let notas = [];

			while (nota <= notaMax) {
				notas.push(
					<Button 
						type="button" 
						key={`${idPesquisa}-${nota}`} 
						id={`${idPesquisa}-${nota}`}
						value={nota}
						{...register(`nota_${idPesquisa}`)}
						onClick={setNotaPesquisa}
					>
						{nota}
					</Button>
				);

				nota++;
			}

			if(permitirLimparNota) {
				setValue(`nota_${idPesquisa}`, null);
				setPermitirLimparNota(false);
			}

			elementos.push(
				<div key={`${idPesquisa}-btnContainer-${i}`}>
					<InputLabel>Nota<span style={{ color: "red" }}>*</span></InputLabel>
					<NotasContainer cols={notaMax + 1}>
						{notas}
					</NotasContainer>
				</div>
			);
		}

		// Gerar campo escolha
		if (tipoNota == "MÚLTIPLA ESCOLHA") {
			elementos.push(
				<div key={`${idPesquisa}-radioContainer-${i}`}>
					<RadioWrapper>
						<ContainerRadioBtn>
							<Campo
								type="radio"
								id={`${idPesquisa}-sim`}
								{...register(`radioanswer_${idPesquisa}`)}
								value="1"
								name={`radioanswer_${idPesquisa}`}
							/>
							<InputLabel pad={"0 0 0 0.7em"} htmlFor={`${idPesquisa}-sim`} style={{ fontSize: 'var(--big-font)' }}>Sim</InputLabel>
						</ContainerRadioBtn>

						<ContainerRadioBtn>
							<Campo
								type="radio"
								id={`${idPesquisa}-nao`}
								{...register(`radioanswer_${idPesquisa}`)}
								value="0"
								name={`radioanswer_${idPesquisa}`}
							/>
							<InputLabel pad={"0 0 0 0.7em"} htmlFor={`${idPesquisa}-nao`} style={{ fontSize: 'var(--big-font)' }}>Não</InputLabel>
						</ContainerRadioBtn>
					</RadioWrapper>
				</div>
			);
		}

		// Gerar campo texto
		if (tipoNota === "TEXTO LIVRE") {
			elementos.push(
				<div key={`${idPesquisa}-textoLivreContainer`}>
					<InputLabel htmlFor={`texto_${idPesquisa}`}>Texto livre<span style={{ color: "red" }}>*</span></InputLabel>
					<TextArea
						name={`texto_${idPesquisa}`}
						id={`texto_${idPesquisa}`}
						placeholder="Digite aqui sua resposta."
						rows="4"
						maxLength={"250"}
						{...register(`texto_${idPesquisa}`)}
						required
					/>
				</div>
			);
		}

		// Gerar campo motivo
		if (tipoNota !== "TEXTO LIVRE" && permitirMotivo == '1') {
			elementos.push(
				<div key={`${idPesquisa}-motivoContainer`}>
					<InputLabel htmlFor={`motivo_${idPesquisa}`}>Motivo</InputLabel>
					<TextArea
						name={`motivo_${idPesquisa}`}
						id={`motivo_${idPesquisa}`}
						placeholder="Descreva o motivo da nota."
						rows="2"
						maxLength={"250"}
						{...register(`motivo_${idPesquisa}`)}
					/>
				</div>
			);
		}

		elementos.push(<Separador key={`sep-${i}`} />);
		return elementos;
	});	

	return (
		<>
			<TituloGeral $color={color}>Pesquisa de satisfação de {titulo}</TituloGeral>

			<FormContainer $bgcolor={$bgcolor} onSubmit={handleSubmit(onSubmit)}>
				<div>
					<InputLabel htmlFor="cliente">CNPJ ou CPF<span style={{ color: "red" }}>*</span></InputLabel>
					<Campo
						type="text"
						name="cliente"
						id="cliente"
						placeholder="Ex.: 11222333444455"
						{...register("cnpj", { minLength: 11, pattern: /^[0-9]+$/ })}
						required
						maxLength={"14"}
					/>
					{errors.cnpj?.type === "pattern" && (
						<p role="alert" className="badge text-bg-danger fw-normal fs-6 m-0">Use apenas números</p>
					)}
					{errors.cnpj?.type === "minLength" && (
						<p role="alert" className="badge text-bg-danger fw-normal fs-6 m-0">Dado incorreto</p>
					)}
				</div>

				<Separador />

				{CamposPesquisas}

				<InputLabel>Campos com asterisco (<span style={{ color: "red" }}>*</span>) são obrigatórios!</InputLabel>

				<Espacador />

				<BotaoEnviar />
			</FormContainer>

			<ModalSucesso
				show={modalShowSuccess}
				onHide={() => setModalSuccessShow(false)}
			/>
			
			<ModalErro
				show={modalShowError}
				onHide={() => setModalErrorShow(false)}
			/>
		</>
	);
}
